var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"ma-0 pa-0",attrs:{"input-value":_vm.value,"color":"#80CBC4","inset":"","dense":"","hide-details":"","x-small":""},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }